<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <!-- <b-link class="brand-logo">
        <b-img
          fluid
          src="@/assets/images/logo/Udara360-logo.png"
          alt="company's-logo"
          width="180"
        />
      </b-link> -->
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex p-0"
      >
        <div
          v-if="institution.loginPageBackgroundURL"
          class="auth-bg-image"
          role="img"
          aria-label="Institution background"
          :style="{
            backgroundImage: 'url(' + institution.loginPageBackgroundURL + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
          }"
        />
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 position-relative"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- <b-card-title
            v-if="institution"
            title-tag="h1"
            class="font-weight-bold mb-1"
          >
            Welcome to {{ institution.prefix }}
          </b-card-title> -->
          <b-card-title
            title-tag="h1"
            class="font-weight-bold mb-1"
          >
            {{ $t("Good to see you again") }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Please sign-in to your account') }}
          </b-card-text>
          <Alert
            ref="alertRef"
            :show="showFormError"
            :message="errorMessage"
            :dismissible="isDismissible"
            :dismiss-secs="30"
          />
          <!-- form -->
          <validation-observer ref="loginForm">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="verifyUser"
            >
              <!-- email -->
              <InputField
                id="email"
                v-model="userDetails.username"
                :label="$t('Email')"
                placeholder="john@company.com"
                type="email"
                error-name="Email"
                rules="required|email"
              />

              <!-- password -->
              <InputPasswordField
                id="password"
                v-model="userDetails.password"
                :label="$t('Password')"
                :text="$t('Forgot Password')"
                path="auth-forgot-password"
                placeholder="Password"
                error-name="Password"
                rules="required"
                vid="password"
              />
              <!-- submit button -->
              <Button
                class="mt-2"
                :label="$t('Sign in')"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                block
                @click="verifyUser"
              />
            </b-form>
          </validation-observer>

          <!-- Version number -->
          <p class="version-text">
            v{{ packageJson.version }}
          </p>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { required } from '@validations'
import {
  BCardText, BCardTitle, BCol, BForm, BRow,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { toastAlert } from '@core/mixins/toast'
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { getVisitorId } from '@/helpers/fingerprintService'
import Alert from '../../components/alert/Alert.vue'
import Button from '../../components/button/Button.vue'
import InputField from '../../forms/InputField.vue'
import InputPasswordField from '../../forms/InputPasswordField.vue'
import capitalizeFirstLetter from '../../../helpers/capitalizeFirstLetter'
import packageJson from '../../../../package.json'
import { redirectAfterLogin } from '../../../router'
import inactivityManager from '@/utils/inactivityManager'
import { DEFAULT_SESSION_TIMEOUT_MINUTES } from '../../../helpers/constants'

export default {
  components: {
    BRow,
    BCol,
    BCardText,
    BCardTitle,
    BForm,
    ValidationObserver,
    InputField,
    InputPasswordField,
    Button,
    Alert,
  },
  mixins: [toastAlert],
  data() {
    return {
      userDetails: {
        password: '',
        username: '',
        visitorID: '',
      },
      isLoading: false,
      hasSessionExpired: false,
      isDisabled: false,
      showFormError: false,
      isDismissible: false,
      errorMessage: '',
      status: '',
      isUseFingerprint: true,
      required,
      timeout: null,
      packageJson,
    }
  },
  computed: {
    ...mapGetters({
      institution: 'auth/getInstitution',
      isSessionExpired: 'auth/getSession',
      message: 'auth/getMessage',
    }),
  },
  async created() {
    const url = window.location.host
    await this.getInstitution(url)

    // Preload LCP background image with high priority
    if (this.institution?.loginPageBackgroundURL) {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'image'
      link.href = this.institution.loginPageBackgroundURL
      link.setAttribute('fetchpriority', 'high')
      document.head.appendChild(link)
    }
  },
  mounted() {
    if (this.isSessionExpired) {
      this.errorMessage = this.message
      this.showFormError = true
      this.isDismissible = true
      this.$refs.alertRef.showAlert()
      this.timeout = setTimeout(() => {
        this.$store.dispatch('auth/updateSessionState', false)
        this.$store.dispatch('auth/updateMessage', '')
      }, 10000)
    } else {
      this.errorMessage = ''
      this.showFormError = false
    }
  },
  beforeDestroy() {
    this.clearTimeout()
  },
  methods: {
    ...mapActions({
      authenticateUser: 'auth/authenticateUser',
      getInstitution: 'auth/getInstitution',
      loginUser: 'auth/loginUser',
    }),
    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    },
    // Helper: Set loading state
    setLoadingState(isLoading) {
      this.isLoading = isLoading
      this.isDisabled = isLoading
    },

    // Helper: Show error message
    displayError(error) {
      if (error.response?.data && Array.isArray(error.response?.data?.errors)) {
        this.errorMessage = error.response.data.errors
          .map(e => e.errorMessage)
          .join(', ')
      } else if (error.message) {
        this.errorMessage = error.message
      } else {
        this.errorMessage = error
      }

      this.showFormError = true
      if (this.$refs.alertRef) {
        this.$refs.alertRef.showAlert()
      }
    },

    // Helper: Navigate to route
    navigateTo(routeName, params = {}) {
      this.$router.push({ name: routeName, params }).catch(() => {})
    },

    // Helper: Get visitor ID with caching
    async getFingerprintVisitorId() {
      if (!this.isUseFingerprint) {
        return ''
      }

      try {
        return await getVisitorId()
      } catch (error) {
        console.error('Fingerprint error:', error)
        // Return empty string if fingerprint fails (non-critical)
        return ''
      }
    },

    // Helper: Handle successful authentication based on response
    async handleAuthenticationSuccess(data) {
      if (data.unauthorisedSystemAccess) {
        this.navigateTo('verified-system-access', { user: this.userDetails })
        return
      }

      if (data.forceChangeOfPassword) {
        this.$store.commit('auth/setForcedChangeOfPassword', true)
        this.navigateTo('setup-security-questions', { user: this.userDetails })
        return
      }

      if (data.enforcePasswordExpiry) {
        this.navigateTo('reset-expired-password', { user: this.userDetails })
        return
      }

      if (data.hasTwoFAenabled && data.newTotpSignup && data.twoFactorOption === 'SOFTWARE') {
        this.navigateTo('create-otp-factor', { user: this.userDetails })
        return
      }

      if (data.hasTwoFAenabled) {
        this.$store.commit('auth/setHasResentToken', true)
        this.navigateTo('verify-token', { user: this.userDetails, data })
        return
      }

      // No 2FA, proceed with direct login
      await this.handleDirectLogin(data)
    },

    // Helper: Handle direct login (without 2FA)
    async handleDirectLogin(authData) {
      const loginResponse = await this.loginUser({
        userToken: '00000',
        username: this.userDetails.username,
        password: this.userDetails.password,
      })

      const {
        userDetails, accessToken, refreshToken, route,
      } = loginResponse.data

      if (userDetails.status.toLowerCase() === 'inactive') {
        this.errorMessage = 'Your account is Inactive. Kindly contact admin'
        this.showFormError = true
        if (this.$refs.alertRef) {
          this.$refs.alertRef.showAlert()
        }
        return
      }

      // Update permissions and tokens
      this.$ability.update([{ action: 'manage', subject: 'all' }])
      useJwt.setToken(accessToken)
      useJwt.setRefreshToken(refreshToken)
      useJwt.setEmail(userDetails.email)

      // Check if password change is required
      if (userDetails.forceChangeOfPassword === true) {
        this.$router.push({ name: 'setup-security-questions' })
        this.toastAlert({
          title: 'Warning',
          icon: 'CoffeeIcon',
          variant: 'warning',
          text: 'Dear User, please change your Password.',
        }).catch(() => {})
        return
      }

      // Handle successful login redirection
      await this.handleLoginRedirection(userDetails, route, authData)
    },

    // Helper: Handle post-login redirection and setup
    async handleLoginRedirection(userDetails, route) {
      try {
        await redirectAfterLogin(route)

        // Update session state
        this.$store.dispatch('auth/updateSessionState', false)

        // Configure inactivity manager - sessionTimeout from API is in minutes
        const sessionTimeout = this.institution?.sessionTimeout || DEFAULT_SESSION_TIMEOUT_MINUTES
        inactivityManager.setInactivityDuration(sessionTimeout)
        inactivityManager.enable()

        // Show welcome message
        this.toastAlert({
          title: `${this.$t('Welcome')} ${capitalizeFirstLetter(userDetails.firstname)} ${capitalizeFirstLetter(userDetails.lastname)}`,
          icon: 'CoffeeIcon',
          variant: 'success',
          text: `${this.$t('You have successfully logged in as')} ${userDetails.role}.`,
        })
      } catch (error) {
        console.error('Login redirection error:', error)
      }
    },

    // Main verification method
    async verifyUser() {
      const success = await this.$refs.loginForm.validate()
      if (!success) {
        return false
      }

      this.showFormError = false
      this.setLoadingState(true)

      try {
        // Get visitor ID (cached)
        this.userDetails.visitorID = await this.getFingerprintVisitorId()

        // Authenticate user
        const response = await this.authenticateUser(this.userDetails)
        const {
          status, data,
        } = response

        if (status === 200 && data?.isSuccessful) {
          await this.handleAuthenticationSuccess(data)
          return true
        }

        return false
      } catch (error) {
        console.log({ error })
        this.displayError(error)
        return false
      } finally {
        this.setLoadingState(false)
      }
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.version-text {
  position: absolute;
  bottom: -250px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
}

/* Media query for smaller screens */
@media (max-height: 650px) {
  .version-text {
    position: relative;
    bottom: auto;
    left: auto;
    transform: none;
    text-align: center;
    margin-top: 20px;
  }
}
</style>
